module.exports = __webpack_public_path__ + "static/1-11f2bc6308c67dc397e13d73d69d149c.jpg";